
export type getImageRelatedsParams = {
  filterByAnimalGroupID: string;
  filterByAnimalID: string;
  filterByImageStatus: string;
  filterByOrganID: string;
  filterByStudyID: string;
  orderByAnimalGroupName: "asc" | "desc" | null;
  orderByImageName: "asc" | "desc" | null;
  page: number | null;
  pageSize: number | null;
}

export const getImageRelateds = (columnNames: string[] = []) => {
  // 从figma来:
  // https://www.figma.com/file/A8zGYY0PxVpgA8ibky6ahz/NonclinicalStudy-flowbite-pro-figma-v2.1.0?node-id=4533%3A43883
  // 可选包括：Project、Block、Scanner、Magnification、
  // Interim Slide Note、Interim Slide Note Status、Slide Note、Slide Note Status、
  // Finding Severity、Last Update、
  // 必选包括：Image(thumbnail)、Slide Name、Group、Animal、Organ、Slide Status
  // TODO: 思路：
  // 1. 应该可以使用columnNames实现“可选”逻辑，但其实也可以直接实现所有的columns，然后进行前端切换
  // 2. 另一个套路是，所有需要的其他columns，如果选中，就进行另一个graphql请求，从当前的状态再进行一次信息获取

  return `
query MyQuery(
  $filterByAnimalGroupID: String, 
  $filterByAnimalID: String, 
  $filterByImageStatus: String, 
  $filterByOrganID: String, 
  $filterByStudyID: String, 
  $orderByAnimalGroupName: String, 
  $orderByImageName: String, 
  $page: Int, 
  $pageSize: Int, 
  $search: String) {
  getImageRelateds(
    filterByAnimalGroupID: $filterByAnimalGroupID, 
    filterByAnimalID: $filterByAnimalID, 
    filterByImageStatus: $filterByImageStatus, 
    filterByOrganID: $filterByOrganID, 
    filterByStudyID: $filterByStudyID, 
    orderByAnimalGroupName: $orderByAnimalGroupName, 
    orderByImageName: $orderByImageName, 
    page: $page, 
    pageSize: $pageSize, 
    search: $search) {
    _total_row_count
    Image {
      ID
      Name
      OrganID
      PPM
      CreatedDate
      BlockName
      BlockNumber
      Dzi
      MagFold
      Metadata
      ModifiedByUserID
      ModifiedDate
      Status
      Organ {
        ID
        Organ
      }
    }
    Animal {
      ID
      Name
      Strain
    }
    AnimalGroup {
      ID
      Name
    }
    Study {
      ID
      Name
      Status
    }
  }
}

`;
};


// Project 按钮的行为
export const getProjectList = `
query MyQuery($filterByStudyID: String) {
  getStudies(filterByStudyID: $filterByStudyID) {
    ID
    Name
    Description
  }
}
`;


// AnimalGroup 按钮的行为
export const getAnimalGroupList = `
query MyQuery($filterByAnimalGroupID: String) {
  getAnimalGroups(filterByAnimalGroupID: $filterByAnimalGroupID) {
    ID
    Name
    StudyID
  }
}`;


// Animal 按钮的行为
export const getAnimalList = `
query MyQuery($filterByAnimalID: String) {
  getAnimals(filterByAnimalID: $filterByAnimalID) {
    AnimalGroupID
    ID
    Name
  }
}`;

